import React, { Component } from "react";

class UnAuthorised extends Component {

    render() {
        return (
            <React.Fragment>
                <div className="wrapper">
                    <header className="header">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-auto">
                                    <div className="logo">
                                        <a><img src="/assets/images/logo.png" alt="" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div className="container" >
                        <div className="whiteBox clientListPage row" >
                            <div className="row titleRow" align="center" style={{ marginLeft: "270px" }}>
                                <img src="/assets/images/401.png" alt="" style={{ marginLeft: "90px" }} />
                                <h4 >Oops....You dont have permission to access this page.</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default UnAuthorised;
